import React from "react"

export default ({
  icon,
  fill,
  opacity,
  height,
  width,
  arrowLeftEmptyTitle,
  arrowRightEmptyTitle,
}) => {
  const svgIcon = {
    copy: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M15 1H4c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm4 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
        />
      </svg>
    ),
    share: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
        />
      </svg>
    ),
    arrowLeft: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <path d="M24 0v24H0V0h24z" fill="none" opacity=".87" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M12.29 8.71L9.7 11.3c-.39.39-.39 1.02 0 1.41l2.59 2.59c.63.63 1.71.18 1.71-.71V9.41c0-.89-1.08-1.33-1.71-.7z"
        />
      </svg>
    ),
    arrowRight: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M11.71 15.29l2.59-2.59c.39-.39.39-1.02 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z"
        />
      </svg>
    ),
    arrowUp: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          // fill={fill ? fill : "#6c757d"}
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M8.71 12.29L11.3 9.7c.39-.39 1.02-.39 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71H9.41c-.89 0-1.33-1.08-.7-1.71z"
        />
      </svg>
    ),
    arrowDown: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"
        />
      </svg>
    ),
    arrowLeftEmpty: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <title>{arrowLeftEmptyTitle}</title>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"
        />
      </svg>
    ),
    arrowBigLeftEmpty: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M16.62 2.99c-.49-.49-1.28-.49-1.77 0L6.54 11.3c-.39.39-.39 1.02 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76z"
        />
      </svg>
    ),
    arrowBigRightEmpty: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31c.39-.39.39-1.02 0-1.41L9.15 2.98c-.49-.49-1.28-.49-1.77 0s-.49 1.28 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76z"
        />
      </svg>
    ),

    arrowRightEmpty: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
      >
        <title>{arrowRightEmptyTitle}</title>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"
        />
      </svg>
    ),
    arrowDownEmpty: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z"
        />
      </svg>
    ),
    fullScreen: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1zm0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
        />
      </svg>
    ),
    fullScreenOut: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M6 16h2v2c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm2-8H6c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v2zm7 11c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm1-11V6c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2z"
        />
      </svg>
    ),
    download: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z"
        />
      </svg>
    ),
    horizonDots: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </svg>
    ),
    moreDots: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </svg>
    ),
    carKey: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "14"}
        height={height ? height : "14"}
        viewBox="0 0 13.098 13.098"
      >
        <path
          d="M.1 10.573l4.022-4.039-.1-.1a.328.328 0 01.11-.537l.473-.19-.444-.444a1.915 1.915 0 010-2.7L6.182.533a1.972 1.972 0 012.7 0l3.658 3.665a1.915 1.915 0 010 2.7l-2.022 2.03a1.906 1.906 0 01-2.7 0l-.448-.449-.189.474a.327.327 0 01-.536.11l-.1-.1-1.729 1.742a.327.327 0 01-.232.1h-.327a.328.328 0 01-.327.328h-.655v.656a.328.328 0 01-.327.328v.328a.328.328 0 01-.1.232l-.327.328a.327.327 0 01-.232.1H.327A.328.328 0 010 12.773v-1.972a.328.328 0 01.1-.228zm6.713-6.59L9.1 6.273a1.023 1.023 0 001.445-1.448l-2.292-2.3a1.025 1.025 0 00-1.444 1.454z"
          fill="#09f"
        />
      </svg>
    ),
    tag: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "13.798"}
        height={height ? height : "13.798"}
        viewBox="0 0 13.798 13.798"
      >
        <path
          fill="red"
          stroke="red"
          strokeWidth="0.3px"
          d="M12.242.15H8.675a2.514 2.514 0 00-1.79.741L.63 7.15a1.639 1.639 0 000 2.317l3.7 3.7a1.639 1.639 0 002.317 0l6.255-6.255a2.514 2.514 0 00.741-1.79V1.556A1.408 1.408 0 0012.242.15zm.844 4.973a1.955 1.955 0 01-.576 1.391l-6.26 6.257a1.1 1.1 0 01-1.521 0L1.027 9.065a1.076 1.076 0 010-1.521l6.256-6.255A1.957 1.957 0 018.675.712h3.567a.845.845 0 01.844.844v3.567z"
        />
        <path
          fill="red"
          stroke="red"
          strokeWidth="0.3px"
          d="M10.555 1.837a1.406 1.406 0 101.406 1.406 1.408 1.408 0 00-1.406-1.406zm0 2.25a.844.844 0 11.844-.844.845.845 0 01-.844.844z"
        />
      </svg>
    ),
    seatBeltOn: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(1600 6164)">
          <g transform="translate(-1600 -6164)" stroke="#09f" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
          <g transform="translate(-1593.56 -6160.32)">
            <path
              id="prefix__Path_3089"
              data-name="Path 3089"
              fill="#09f"
              d="M175.532 305.325a.642.642 0 00-.629-.028.325.325 0 00-.11.09l-.728.935h-1.625l-.728-.935a.325.325 0 00-.111-.09.647.647 0 00-.936.578v3.357a.323.323 0 00.323.323h.323v1.617a.323.323 0 00.323.323h3.233a.323.323 0 00.323-.323v-1.617h.323a.323.323 0 00.323-.323v-3.357a.643.643 0 00-.304-.55z"
              transform="translate(-168.08 -295.983)"
            />
            <path
              id="prefix__Path_3090"
              data-name="Path 3090"
              fill="#09f"
              d="M175.515 149.333h-4.526a.323.323 0 00-.323.323v1.74a.644.644 0 00.357.578l.936.468v.77a.647.647 0 00.647.647h1.294a.647.647 0 00.647-.647v-.77l.936-.469a.643.643 0 00.357-.578v-1.74a.323.323 0 00-.325-.322zm-2.263 1.94a.323.323 0 11.323-.323.323.323 0 01-.323.323z"
              transform="translate(-168.08 -144.81)"
            />
            <path
              id="prefix__Path_3091"
              data-name="Path 3091"
              fill="#09f"
              d="M91.2 3.88a.324.324 0 00.263-.511L89.154.135A.325.325 0 0088.891 0h-3.233a.324.324 0 00-.263.511L87.7 3.744a.325.325 0 00.263.135z"
              transform="translate(-85.335)"
            />
            <path
              id="prefix__Path_3092"
              data-name="Path 3092"
              fill="#09f"
              d="M276.2.176a.323.323 0 00-.286-.176h-3.233a.326.326 0 00-.263.135l-.822 1.15a.324.324 0 000 .376l1.488 2.082a.325.325 0 00.263.135h.258a.325.325 0 00.263-.135l2.31-3.232a.324.324 0 00.022-.335z"
              transform="translate(-265.892)"
            />
          </g>
        </g>
      </svg>
    ),
    seatBeltOff: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(1086 -4308)">
          <g transform="translate(-1079.56 4311.68)">
            <g transform="translate(2.586 9.249)">
              <path
                fill="#707070"
                d="M175.532 305.327a.641.641 0 00-.629-.028.326.326 0 00-.11.09l-.728.935h-1.623l-.728-.934a.321.321 0 00-.111-.091.646.646 0 00-.935.578v3.356a.323.323 0 00.323.323h.323v1.616a.323.323 0 00.323.323h3.232a.323.323 0 00.323-.323v-1.616h.323a.323.323 0 00.323-.323v-3.356a.642.642 0 00-.306-.55zm-.986 5.522h-2.586v-1.293h2.586zm.646-1.939h-3.879v-2.981l.714.917a.323.323 0 00.255.125h1.939a.324.324 0 00.255-.124l.715-.918z"
                transform="translate(-170.667 -305.23)"
              />
            </g>
            <path
              fill="#707070"
              d="M95.643.175A.323.323 0 0095.356 0h-3.233a.323.323 0 00-.263.135L90.507 2.03 89.154.135A.323.323 0 0088.891 0h-3.232a.323.323 0 00-.259.511l2.867 4.014h-.019a.323.323 0 00-.323.323v1.74a.642.642 0 00.357.578l.936.468V8.4a.647.647 0 00.646.646h1.293A.647.647 0 0091.8 8.4v-.77l.935-.468a.642.642 0 00.358-.578V4.848a.323.323 0 00-.323-.323h-.019L95.619.511a.323.323 0 00.024-.336zm-9.356.471h2.438L91.5 4.525h-2.443zm6.16 5.942l-1.114.557a.323.323 0 00-.179.289V8.4h-1.293v-.97a.323.323 0 00-.179-.289l-1.114-.557V5.172h3.879zm-.323-2.3L90.9 2.586l1.39-1.94h2.438z"
              transform="translate(-85.336)"
            />
            <g transform="translate(4.848 5.818)">
              <circle fill="#707070" cx={0.323} cy={0.323} r={0.323} />
            </g>
          </g>
          <g transform="translate(-1086 4308)" stroke="#707070" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
        </g>
      </svg>
    ),
    wifi: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "13.204"}
        height={height ? height : "13.319"}
        viewBox="0 0 13.204 13.319"
      >
        <path
          fill="#707070"
          className="prefix__a"
          d="M.91 7.13A11.664 11.664 0 017.069.917a11.417 11.417 0 014.505-.918 1.644 1.644 0 010 3.288 8.36 8.36 0 00-8.314 8.386 1.639 1.639 0 01-1.63 1.644 1.639 1.639 0 01-1.631-1.643 11.689 11.689 0 01.91-4.545zm.72 5.408a.861.861 0 00.856-.864 9.18 9.18 0 012.662-6.482 9.055 9.055 0 012.889-1.964 8.965 8.965 0 013.538-.72.864.864 0 000-1.727A10.86 10.86 0 00.774 11.674a.861.861 0 00.856.864zm0 0"
        />
        <path
          fill="#707070"
          d="M11.572 5.014a1.644 1.644 0 010 3.288 3.361 3.361 0 00-3.34 3.372 1.639 1.639 0 01-1.63 1.64 1.639 1.639 0 01-1.63-1.64 6.645 6.645 0 011.934-4.709 6.53 6.53 0 014.666-1.951zm-4.97 7.524a.861.861 0 00.856-.864 4.139 4.139 0 014.114-4.151.864.864 0 000-1.727 5.86 5.86 0 00-5.826 5.878.861.861 0 00.856.864zm0 0M11.574 10.032a1.644 1.644 0 010 3.288 1.644 1.644 0 010-3.288zm0 2.508a.864.864 0 10-.856-.864.861.861 0 00.856.862zm0 0"
        />
      </svg>
    ),
    acOn: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g stroke="#09f" fill="none">
          <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
          <circle cx={11.5} cy={11.5} r={11} />
        </g>
        <path
          d="M19.241 10.886h-1.506l.373-.5a.354.354 0 00.071-.217l-.008-.708a.354.354 0 00-.627-.222l-1.365 1.647h-2.67l2.127-2.127h1.479a.355.355 0 00.354-.362l-.008-.349a.354.354 0 00-.353-.347h-.413l.67-.67a.355.355 0 000-.5l-.5-.5a.354.354 0 00-.5 0l-.668.668v-.412a.355.355 0 00-.345-.354L15 5.924a.342.342 0 00-.256.1.355.355 0 00-.107.254v1.479l-2.13 2.126V7.215l1.647-1.363a.354.354 0 00-.221-.628l-.712-.01a.271.271 0 00-.221.072l-.5.372V4.151a.354.354 0 00-.348-.354h-.709a.354.354 0 00-.354.354v1.507l-.5-.372a.409.409 0 00-.217-.071l-.708.008a.354.354 0 00-.222.627l1.647 1.364v2.67L8.962 7.757V6.278a.354.354 0 00-.354-.354h-.355a.354.354 0 00-.354.354v.419l-.666-.67a.354.354 0 00-.5 0l-.5.5a.355.355 0 000 .5l.667.67h-.419a.354.354 0 00-.354.354v.354a.354.354 0 00.354.354H7.96l2.126 2.127H7.418L6.057 9.241a.354.354 0 00-.628.221l-.01.711a.354.354 0 00.071.217l.371.495H4.354A.354.354 0 004 11.24v.709a.354.354 0 00.354.354h1.51l-.374.494a.351.351 0 00-.071.217l.008.708a.354.354 0 00.236.33.35.35 0 00.118.02.354.354 0 00.273-.128l1.366-1.64h2.666L7.96 14.43H6.481a.354.354 0 00-.354.354v.354a.354.354 0 00.354.354H6.9l-.666.666a.354.354 0 000 .5l.5.5a.354.354 0 00.5 0l.673-.673v.419a.355.355 0 00.35.352h.345a.355.355 0 00.354-.354v-1.469l2.133-2.127v2.672l-1.643 1.359a.354.354 0 00.221.628l.712.01a.432.432 0 00.217-.071l.493-.369v1.5a.354.354 0 00.354.354h.709a.354.354 0 00.354-.354v-1.506l.5.375a.354.354 0 00.213.071l.708-.008a.354.354 0 00.222-.627l-1.642-1.368v-2.666l2.127 2.127v1.479a.354.354 0 00.354.354h.354a.354.354 0 00.354-.354v-.415l.666.666a.354.354 0 00.5 0l.5-.5a.354.354 0 000-.5l-.662-.666h.415a.354.354 0 00.354-.354v-.354a.354.354 0 00-.354-.354h-1.479l-2.127-2.131h2.672l1.362 1.644a.355.355 0 00.273.128.359.359 0 00.118-.02.355.355 0 00.236-.33l.009-.711a.353.353 0 00-.071-.218l-.371-.495h1.5a.354.354 0 00.354-.354v-.708a.354.354 0 00-.35-.354z"
          fill="#09f"
        />
      </svg>
    ),
    acOff: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <path
          d="M18.934 11.025h-2.128l.97-1.213a.36.36 0 10-.562-.449l-1.33 1.663h-3.631l2.516-2.516h2.007a.36.36 0 100-.719h-1.288l1.543-1.543a.36.36 0 00-.508-.508l-1.547 1.542v-1.29a.36.36 0 10-.719 0v2.009l-2.513 2.516V6.884l1.663-1.33a.36.36 0 00-.449-.562l-1.213.971V3.836a.36.36 0 10-.719 0v2.127l-1.214-.97a.36.36 0 00-.449.562l1.663 1.33v3.632L8.509 8.001V5.992a.36.36 0 10-.719 0v1.29L6.247 5.738a.36.36 0 00-.508.508L7.282 7.79h-1.29a.36.36 0 000 .719h2.009l2.516 2.516H6.884l-1.33-1.662a.36.36 0 10-.562.449l.971 1.213H3.836a.36.36 0 000 .719h2.128l-.971 1.214a.36.36 0 00.562.449l1.33-1.663h3.632l-2.516 2.517H5.992a.36.36 0 100 .719h1.29l-1.544 1.544a.36.36 0 10.508.508l1.544-1.544v1.288a.36.36 0 10.719 0v-2.007l2.516-2.516v3.633l-1.662 1.33a.36.36 0 10.449.562l1.213-.971v2.128a.36.36 0 00.719 0v-2.128l1.213.971a.36.36 0 00.449-.562l-1.663-1.33v-3.633l2.516 2.516v2.007a.36.36 0 10.719 0v-1.288l1.543 1.543a.36.36 0 10.508-.508l-1.541-1.547h1.288a.36.36 0 000-.719h-2.007l-2.516-2.513h3.633l1.33 1.663a.36.36 0 00.562-.449l-.972-1.214h2.128a.36.36 0 100-.719z"
          fill="#707070"
        />
        <g stroke="#707070" fill="none">
          <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
          <circle cx={11.5} cy={11.5} r={11} />
        </g>
      </svg>
    ),
    watch: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "13.409"}
        height={height ? height : "13.409"}
        viewBox="0 0 13.409 13.409"
      >
        <g transform="translate(0.15 0.15)">
          <path
            fill="#198000"
            stroke="#198000"
            strokeWidth="0.3px"
            d="M6.554,0a6.554,6.554,0,1,0,6.554,6.554A6.562,6.562,0,0,0,6.554,0Zm0,12.29A5.735,5.735,0,1,1,12.29,6.554,5.741,5.741,0,0,1,6.554,12.29Z"
          />
          <path
            fill="#198000"
            stroke="#198000"
            strokeWidth="0.3px"
            d="M243.277,108.842a.407.407,0,0,1-.29-.12l-2.868-2.868a.41.41,0,0,1-.12-.289v-3.823a.41.41,0,1,1,.819,0V105.4l2.747,2.747a.41.41,0,0,1-.29.7Z"
            transform="translate(-233.855 -98.738)"
          />
        </g>
      </svg>
    ),
    location: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "13.426"}
        height={height ? height : "13.205"}
        viewBox="0 0 13.426 13.205"
      >
        <g fill="#0074f9" stroke="#0074f9">
          <path d="M4.458 9.027a36.35 36.35 0 001.436 1.88l.148.18H4.964a.218.218 0 100 .437h3.5a.218.218 0 100-.437H7.382l.148-.18c.357-.437.9-1.119 1.436-1.88a19.2 19.2 0 001.443-2.326 5.11 5.11 0 00.673-2.162 4.367 4.367 0 00-1.279-3.094.218.218 0 10-.309.309 3.931 3.931 0 011.152 2.785 4.71 4.71 0 01-.625 1.963A18.763 18.763 0 018.61 8.774a35.962 35.962 0 01-1.731 2.235.221.221 0 01-.333 0c-.09-.107-.2-.235-.313-.378a35.528 35.528 0 01-1.418-1.857 18.762 18.762 0 01-1.412-2.271 4.7 4.7 0 01-.625-1.963A3.934 3.934 0 018.242.911a.219.219 0 00.171-.4 4.371 4.371 0 00-6.07 4.028 5.118 5.118 0 00.673 2.163 19.183 19.183 0 001.442 2.325z" />
          <path d="M6.713 2.567a.218.218 0 000-.437 2.185 2.185 0 101.545.64.218.218 0 10-.309.309 1.748 1.748 0 11-1.236-.512zM13.185 12.087l-1.344-2.4a.679.679 0 00-.594-.343H9.69a.218.218 0 000 .437h1.557a.242.242 0 01.213.119l1.343 2.4a.2.2 0 010 .2.24.24 0 01-.211.116H.836a.24.24 0 01-.211-.116.2.2 0 010-.2l1.343-2.4a.242.242 0 01.213-.119h1.555a.218.218 0 000-.437H2.179a.679.679 0 00-.595.343l-1.343 2.4a.634.634 0 00.007.636.673.673 0 00.588.332H12.59a.673.673 0 00.588-.332.634.634 0 00.007-.636z" />
          <path d="M10.864 10.433H9.99a.22.22 0 00-.121.037l-.655.437a.219.219 0 10.242.364l.6-.4h.808a.219.219 0 000-.437zM9.553 11.962a.218.218 0 00.218.219h1.745a.218.218 0 100-.437H9.768a.218.218 0 00-.215.218zM4.091 11.307a.218.218 0 00.121-.4l-.655-.437a.22.22 0 00-.121-.037h-.874a.218.218 0 000 .437h.808l.6.4a.218.218 0 00.121.037zM1.905 11.744a.218.218 0 100 .437H3.65a.218.218 0 100-.437z" />
        </g>
      </svg>
    ),
    updateWatch: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "16.143"}
        height={height ? height : "13.387"}
        viewBox="0 0 16.143 13.387"
      >
        <g transform="translate(0.15 0.15)">
          <path
            fill="#944f00"
            stroke="#944f00"
            strokeWidth="0.3px"
            d="M247.744,103.577a.346.346,0,0,1-.244-.1l-2.066-2.066a.347.347,0,0,1-.1-.244V96.344a.344.344,0,0,1,.689,0v4.679l1.966,1.966a.344.344,0,0,1-.244.588Z"
            transform="translate(-237.756 -94.077)"
          />
          <g>
            <path
              fill="#944f00"
              stroke="#944f00"
              strokeWidth="0.3px"
              d="M14,59.432a.344.344,0,0,0-.487-.487l-.788.788a5.851,5.851,0,0,1,11.35-1.854.344.344,0,0,0,.647-.236,6.54,6.54,0,0,0-12.686,2.094l-.792-.791a.344.344,0,0,0-.487.487l1.378,1.378a.345.345,0,0,0,.487,0Z"
              transform="translate(-10.661 -53.333)"
            />
            <path
              fill="#944f00"
              stroke="#944f00"
              strokeWidth="0.3px"
              d="M79.041,225.473,77.663,224.1a.345.345,0,0,0-.487,0L75.8,225.473a.344.344,0,0,0,.487.487l.788-.788a5.851,5.851,0,0,1-11.35,1.855.344.344,0,0,0-.647.236,6.54,6.54,0,0,0,12.686-2.093l.791.792a.345.345,0,0,0,.488-.488Z"
              transform="translate(-63.299 -218.485)"
            />
          </g>
        </g>
      </svg>
    ),
    coordinate: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "13.409"}
        height={height ? height : "13.409"}
        viewBox="0 0 13.409 13.409"
      >
        <g transform="translate(2067.15 5927.576)">
          <path
            fill="#a700a7"
            stroke="#a700a7"
            strokeWidth="0.3px"
            d="M6.554,0a6.554,6.554,0,1,0,6.554,6.554A6.562,6.562,0,0,0,6.554,0Zm0,12.563a6.008,6.008,0,1,1,6.008-6.008A6.015,6.015,0,0,1,6.554,12.563Z"
            transform="translate(-2067 -5927.426)"
          />
          <path
            fill="#a700a7"
            stroke="#a700a7"
            strokeWidth="0.3px"
            d="M235.213,235.759a.546.546,0,1,0-.546-.546A.547.547,0,0,0,235.213,235.759Z"
            transform="translate(-2295.659 -6156.085)"
          />
          <path
            fill="#a700a7"
            stroke="#a700a7"
            strokeWidth="0.3px"
            d="M123.83,117.147l-4.375,2.19a.273.273,0,0,0-.122.122l-2.19,4.375a.273.273,0,0,0,.366.366l4.375-2.19a.273.273,0,0,0,.122-.122l2.19-4.375a.273.273,0,0,0-.366-.366Zm-2.272,4.416L118,123.345l1.782-3.56,3.56-1.782Z"
            transform="translate(-2181.115 -6041.546)"
          />
        </g>
      </svg>
    ),
    printer: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "rgba(0, 0, 0, 0.45)"}
          d="M19 8H5c-1.66 0-3 1.34-3 3v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h2c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm-4 11H9c-.55 0-1-.45-1-1v-4h8v4c0 .55-.45 1-1 1zm4-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-9H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
        />
      </svg>
    ),
    building: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <g>
          <rect fill="none" height="24" width="24" />
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <path
            fill={fill ? fill : "#000"}
            d="M17,11V5c0-1.1-0.9-2-2-2H9C7.9,3,7,3.9,7,5v2H5C3.9,7,3,7.9,3,9v10c0,1.1,0.9,2,2,2h5c0.55,0,1-0.45,1-1v-3h2v3 c0,0.55,0.45,1,1,1h5c1.1,0,2-0.9,2-2v-6c0-1.1-0.9-2-2-2H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15 z M11,11H9V9h2V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z"
          />
        </g>
      </svg>
    ),
    phone: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
        />
      </svg>
    ),
    email: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
        />
      </svg>
    ),
    message: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 12H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
        />
      </svg>
    ),
    userCircle: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
        />
      </svg>
    ),
    pauseCircle: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
        />
      </svg>
    ),
    playCircle: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        />
      </svg>
    ),
    rePlay: () => (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          d="M-35.48-.19h24v24h-24Z"
          transform="translate(35.48 0.19)"
        />
        <circle fill={fill ? fill : "#000"} cx="12" cy="12" r="10" />
        <circle fill="#fff" cx="12" cy="12" r="8" />
        <path
          fill={fill ? fill : "#000"}
          stroke={fill ? fill : "#000"}
          stroke-miterlimit="10"
          strokeWidth="0.5px"
          d="M-19.15,12.57a4.26,4.26,0,0,1-4.11,3.16,4.25,4.25,0,0,1-4.25-4.26,4.25,4.25,0,0,1,4.25-4.25,4.27,4.27,0,0,1,2.8,1l-.67,1.16a2.93,2.93,0,0,0-2.13-.91,3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,2.74-1.86h-1l1.77-3.07L-18,12.57Z"
          transform="translate(35.48 0.19)"
        />
      </svg>
    ),
    removeCircleOutline: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        />
      </svg>
    ),
    removeCircleFill: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
        />
      </svg>
    ),
    map: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M14.65 4.98l-5-1.75c-.42-.15-.88-.15-1.3-.01L4.36 4.56C3.55 4.84 3 5.6 3 6.46v11.85c0 1.41 1.41 2.37 2.72 1.86l2.93-1.14c.22-.09.47-.09.69-.01l5 1.75c.42.15.88.15 1.3.01l3.99-1.34c.81-.27 1.36-1.04 1.36-1.9V5.69c0-1.41-1.41-2.37-2.72-1.86l-2.93 1.14c-.22.08-.46.09-.69.01zM15 18.89l-6-2.11V5.11l6 2.11v11.67z"
        />
      </svg>
    ),
    time: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z"
        />
      </svg>
    ),
    distance: () => (
      <svg
        version="1.1"
        id="IconsRepoEditor"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width={width ? width : "40px"}
        height={height ? height : "40px"}
        viewBox="0 0 480.543 480.543"
        style={{ enableBackground: "new 0 0 480.543 480.543" }}
        xmlSpace="preserve"
        fill="#000000"
        stroke="#000000"
        strokeWidth="0"
      >
        <g id="IconsRepo_bgCarrier" />
        <path
          fill={fill ? fill : "#000"}
          d="M225.278,278.426c0-48.641-39.572-88.213-88.214-88.213c-48.641,0-88.212,39.572-88.212,88.213 c0,14.254,3.401,27.727,9.431,39.654l78.781,162.463l78.795-162.488C221.88,306.133,225.278,292.669,225.278,278.426z M137.064,327.243c-26.917,0-48.817-21.9-48.817-48.817s21.9-48.817,48.817-48.817c26.918,0,48.817,21.9,48.817,48.817 S163.982,327.243,137.064,327.243z"
        />
        <path
          fill={fill ? fill : "#000"}
          d="M387.021,0c-24.63,0-44.669,20.038-44.669,44.668c0,7.218,1.723,14.04,4.776,20.081l39.893,82.267l39.899-82.28 c3.049-6.037,4.77-12.855,4.77-20.067C431.69,20.038,411.65,0,387.021,0z M387.021,69.388c-13.631,0-24.72-11.089-24.72-24.72 c0-13.63,11.089-24.72,24.72-24.72c13.629,0,24.719,11.09,24.719,24.72C411.74,58.299,400.65,69.388,387.021,69.388z"
        />
        <path
          fill={fill ? fill : "#000"}
          d="M348.116,289.787c-1.812-8.523-4.166-16.875-7.131-25.075c-3.974-10.987-8.74-21.724-12.391-32.836 c-6.823-20.771,4.948-38.105,7.16-41.256c3.876-5.517,8.408-10.58,13.19-15.322c9.207-9.128,19.361-17.288,29.984-24.803 c-1.316-2.039-2.591-4.1-3.805-6.199c-15.279,5.99-93.854,33.452-91.938,94.121c0.384,12.162,5.083,23.737,7.979,35.526 c1.395,5.681,2.605,11.412,3.345,17.218c0.319,2.614,0.515,5.243,0.729,7.87c0.006-0.02,0.004-0.034-0.008-0.045 c0.007,0.076,0.202,8.326-0.164,11.9c-1.147,11.189-2.799,22.494-7.516,32.758c-4.387,9.543-11.006,17.842-19.193,24.402 c-18.716,14.994-43.514,20.988-66.913,23.398c-1.114,0.117-2.228,0.217-3.342,0.314l-41.779,86.152 c20.614-1.281,41.175-4.102,61.235-9.039c23.607-5.811,46.613-14.588,67.227-27.598c20.596-12.996,38.308-30.578,50.099-51.984 c12.335-22.391,17.277-48.038,16.225-73.452C350.752,307.156,349.928,298.307,348.116,289.787z"
        />
      </svg>
    ),
    speed: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M19.46 10a1 1 0 0 0-.07 1 7.55 7.55 0 0 1 .52 1.81 8 8 0 0 1-.69 4.73 1 1 0 0 1-.89.53H5.68a1 1 0 0 1-.89-.54A8 8 0 0 1 13 6.06a7.69 7.69 0 0 1 2.11.56 1 1 0 0 0 1-.07 1 1 0 0 0-.17-1.76A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0 .55-8.89 1 1 0 0 0-1.75-.11z"
        />
        <path
          fill={fill ? fill : "#000"}
          d="M10.59 12.59a2 2 0 0 0 2.83 2.83l5.66-8.49z"
        />
      </svg>
    ),
    // clear: () => (
    close: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
        />
      </svg>
    ),
    alert: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path
          fill={fill ? fill : "#000"}
          d="M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm8.29-4.71L19 17v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-1.29 1.29c-.63.63-.19 1.71.7 1.71h15.17c.9 0 1.34-1.08.71-1.71zM13 16h-2v-2h2v2zm0-5c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v2z"
        />
      </svg>
    ),
    alertOutline: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path
          fill={fill ? fill : "#000"}
          d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z"
        />
      </svg>
    ),
    warning: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"
        />
      </svg>
    ),
    batteryDisconnect: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
        />
      </svg>
    ),
    checkCircle: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
        />
      </svg>
    ),
    unCheckCircle: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"
        />
      </svg>
    ),
    payment: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zm1-10H4V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1z"
        />
      </svg>
    ),
    record: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M14 15H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-8H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM4 13h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
        />
      </svg>
    ),
    level: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
          fill={fill ? fill : "#000"}
          d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        />
      </svg>
    ),
    drop: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z" />
        <path
          fill={fill ? fill : "#000"}
          d="M17.66 8l-4.95-4.94c-.39-.39-1.02-.39-1.41 0L6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
        />
      </svg>
    ),
    logOut: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 30 30"
      >
        <path d="M 14.984375 2.9863281 A 1.0001 1.0001 0 0 0 14 4 L 14 15 A 1.0001 1.0001 0 1 0 16 15 L 16 4 A 1.0001 1.0001 0 0 0 14.984375 2.9863281 z M 9.9960938 4.2128906 A 1.0001 1.0001 0 0 0 9.5449219 4.328125 C 5.6645289 6.3141271 3 10.347825 3 15 C 3 21.615466 8.3845336 27 15 27 C 21.615466 27 27 21.615466 27 15 C 27 10.347825 24.335471 6.3141271 20.455078 4.328125 A 1.0001544 1.0001544 0 1 0 19.544922 6.109375 C 22.780529 7.7653729 25 11.110175 25 15 C 25 20.534534 20.534534 25 15 25 C 9.4654664 25 5 20.534534 5 15 C 5 11.110175 7.2194712 7.7653729 10.455078 6.109375 A 1.0001 1.0001 0 0 0 9.9960938 4.2128906 z"></path>
      </svg>
    ),
    tools: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "14.842"}
        height={height ? height : "13.679"}
        viewBox="0 0 14.842 13.679"
      >
        <defs>
          <style>
            {".prefix__a{fill:#ff6f00;stroke:#ff6f00;stroke-width:.3px}"}
          </style>
        </defs>
        <path
          className="prefix__a"
          d="M12.563 2.241a7.368 7.368 0 00-10.283 0 7.049 7.049 0 00.327 10.4.219.219 0 00.3-.018.209.209 0 00-.019-.3 6.63 6.63 0 01-.308-9.779 6.93 6.93 0 019.672 0 6.63 6.63 0 01-.308 9.779.209.209 0 00-.019.3.219.219 0 00.3.018 7.049 7.049 0 00.327-10.4z"
        />
        <path
          className="prefix__a"
          d="M10.226 11.621h-4.7a.21.21 0 100 .419h4.7a.3.3 0 01.3.3v.469a.3.3 0 01-.3.3H4.618a.3.3 0 01-.3-.3v-.469a.3.3 0 01.3-.3h.208a.21.21 0 100-.419h-.208a.72.72 0 00-.719.719v.469a.72.72 0 00.719.719h5.608a.72.72 0 00.719-.719v-.469a.72.72 0 00-.719-.719zM10.77 2.455a5.941 5.941 0 00-9.028 2.437.21.21 0 00.368.2 4.862 4.862 0 017.261-.951.21.21 0 00.278-.315 5.283 5.283 0 00-6.43-.429 5.524 5.524 0 017.3-.606.21.21 0 10.252-.336zM12.278 3.56a.21.21 0 10-.328.261 5.455 5.455 0 011.2 3.228h-1.349a5.229 5.229 0 00-.558-1.691.21.21 0 00-.37.2 4.816 4.816 0 01.536 1.728.21.21 0 00.208.186h1.746a.21.21 0 00.21-.21 5.876 5.876 0 00-1.295-3.702zM11.805 2.62a.21.21 0 00-.28.045l-3.639 4.6a.21.21 0 00.329.26l2.171-2.743-2.454 4.57c-.019.03-.05.08-.066.1a.461.461 0 11-.721-.575l.656-.829a.21.21 0 00-.329-.26l-.656.828a.881.881 0 00.687 1.43.9.9 0 00.1-.006.875.875 0 00.59-.327 1.733 1.733 0 00.1-.148l.005-.009 3.576-6.659a.21.21 0 00-.069-.277z"
        />
        <path
          className="prefix__a"
          d="M7.624 9.04a.21.21 0 10-.032.27.211.211 0 00.032-.27z"
        />
      </svg>
    ),
    route: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15.027}
        height={15.092}
        viewBox="0 0 15.027 15.092"
      >
        <defs>
          <style>
            {".prefix__a{fill:#0074f9;stroke:#0074f9;stroke-width:.3px}"}
          </style>
        </defs>
        <path
          className="prefix__a"
          d="M5.391 7.293a2.791 2.791 0 00-2.1-.98 2.79 2.79 0 00-2.1.98 3.608 3.608 0 000 4.659l2.1 2.375 2.1-2.375a3.608 3.608 0 000-4.659zm-.364 4.333l-1.738 1.958-1.733-1.958a3.1 3.1 0 010-4.005 2.3 2.3 0 011.733-.814 2.3 2.3 0 011.733.814 3.1 3.1 0 01.005 4.005zM12.226 6.192l1.594-1.8a2.709 2.709 0 000-3.5 2.085 2.085 0 00-3.187 0 2.709 2.709 0 000 3.5zm-1.225-4.974a1.592 1.592 0 012.45 0 2.2 2.2 0 010 2.85L12.226 5.45l-1.225-1.382a2.2 2.2 0 010-2.85zM13.178 13.592a.246.246 0 00-.295.186.855.855 0 01-.163.343.247.247 0 10.388.3 1.359 1.359 0 00.257-.539.247.247 0 00-.187-.29zM8.097 7.793a.867.867 0 01-.309-.057.247.247 0 00-.176.461 1.361 1.361 0 00.484.089h.088a.247.247 0 100-.493zM7.511 6.234a.247.247 0 00.13-.037.851.851 0 01.358-.124.247.247 0 10-.054-.49 1.337 1.337 0 00-.566.2.247.247 0 00.131.456zM4.659 14.449h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493zM9.083 10.011H9.02a.247.247 0 00.01.493h.493a.247.247 0 000-.493zM8.96 6.067h.493a.247.247 0 100-.493H8.96a.247.247 0 100 .493zM11.988 10.011a.247.247 0 000 .493h.493a.247.247 0 000-.493zM12.869 8.04a.246.246 0 00-.246-.247h-.491a.247.247 0 100 .493h.493a.246.246 0 00.244-.246zM10.509 10.504h.493a.247.247 0 000-.493h-.493a.247.247 0 000 .493zM10.932 6.067a.247.247 0 000-.493h-.493a.247.247 0 100 .493zM9.173 7.793a.247.247 0 000 .493h.493a.247.247 0 000-.493zM11.389 8.04a.246.246 0 00-.246-.247h-.491a.247.247 0 100 .493h.493a.246.246 0 00.244-.246zM14.859 8.937a.247.247 0 10-.487.078.812.812 0 01.01.136.863.863 0 01-.035.244.246.246 0 00.167.306.25.25 0 00.069.01.247.247 0 00.237-.177 1.358 1.358 0 00.055-.38 1.312 1.312 0 00-.016-.217zM10.576 14.449h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493zM9.096 14.449h-.493a.247.247 0 000 .493h.493a.247.247 0 100-.493zM11.812 12.477a.246.246 0 00-.251-.247h-.493a.247.247 0 000 .493h.493a.246.246 0 00.251-.246zM10.333 12.477a.246.246 0 00-.251-.247h-.493a.247.247 0 000 .493h.493a.246.246 0 00.251-.246zM12.041 14.449h-.475a.247.247 0 100 .493h.49l.007-.247v.247a.239.239 0 00.238-.247.254.254 0 00-.26-.246zM12.913 13.147a.247.247 0 00.194-.4 1.366 1.366 0 00-.463-.377.247.247 0 10-.22.442.865.865 0 01.3.24.247.247 0 00.189.095zM13.854 9.945a.856.856 0 01-.333.067h-.053a.247.247 0 100 .493h.053a1.346 1.346 0 00.524-.105.247.247 0 00-.191-.455zM7.119 7.512a.247.247 0 00.157-.311.861.861 0 01-.043-.268.966.966 0 01.007-.111.246.246 0 10-.489-.062 1.434 1.434 0 00-.011.171 1.357 1.357 0 00.067.424.247.247 0 00.234.17.239.239 0 00.078-.013zM6.138 14.449h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493zM8.621 12.623a.247.247 0 00.1-.471.872.872 0 01-.3-.231.247.247 0 10-.377.317 1.365 1.365 0 00.475.362.248.248 0 00.102.023zM14.199 7.975a1.341 1.341 0 00-.571-.178.247.247 0 00-.038.492.849.849 0 01.362.113.247.247 0 10.247-.427zM7.617 14.449h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493zM8.235 11.205a.856.856 0 01.153-.348.248.248 0 10-.4-.292 1.351 1.351 0 00-.24.548.247.247 0 00.2.289.246.246 0 00.289-.2z"
        />
        <path
          className="prefix__a"
          d="M12.287 3.848a1.356 1.356 0 10-1.356-1.356 1.358 1.358 0 001.356 1.356zm0-2.219a.863.863 0 11-.863.863.864.864 0 01.863-.863zM3.289 7.793a1.479 1.479 0 101.479 1.479 1.481 1.481 0 00-1.479-1.479zm0 2.465a.986.986 0 11.986-.986.987.987 0 01-.986.986z"
        />
      </svg>
    ),
    edit: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        />
      </svg>
    ),
    setting: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
        />
      </svg>
    ),
    reset: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M17.65 6.35c-1.63-1.63-3.94-2.57-6.48-2.31-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20c3.19 0 5.93-1.87 7.21-4.56.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53-1.13 2.43-3.84 3.97-6.8 3.31-2.22-.49-4.01-2.3-4.48-4.52C5.31 9.44 8.26 6 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71l-.64.65z"
        />
      </svg>
    ),
    tick: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
        />
      </svg>
    ),
    users: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V18c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h6v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
        />
      </svg>
    ),
    movePointer: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M10.5 9h3c.28 0 .5-.22.5-.5V6h1.79c.45 0 .67-.54.35-.85l-3.79-3.79c-.2-.2-.51-.2-.71 0L7.85 5.15c-.31.31-.09.85.36.85H10v2.5c0 .28.22.5.5.5zm-2 1H6V8.21c0-.45-.54-.67-.85-.35l-3.79 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.31.31.85.09.85-.36V14h2.5c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm14.15 1.65l-3.79-3.79c-.32-.32-.86-.1-.86.35V10h-2.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5H18v1.79c0 .45.54.67.85.35l3.79-3.79c.2-.19.2-.51.01-.7zM13.5 15h-3c-.28 0-.5.22-.5.5V18H8.21c-.45 0-.67.54-.35.85l3.79 3.79c.2.2.51.2.71 0l3.79-3.79c.31-.31.09-.85-.35-.85H14v-2.5c0-.28-.22-.5-.5-.5z"
        />
      </svg>
    ),
    user: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
        />
      </svg>
    ),
    search: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        />
      </svg>
    ),
    addUser: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H6zm9 4c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
        />
      </svg>
    ),
    settingIcon: () => (
      <svg
        id="prefix__Component_44_94"
        data-name="Component 44 \u2013 94"
        width={17}
        height={17}
        viewBox="0 0 17 17"
      >
        <defs>
          <style>
            {".prefix__cls-1{fill:#e8edfc}.prefix__cls-3{fill:#5d61e8}"}
          </style>
        </defs>
        <g id="prefix__Group_944" data-name="Group 944">
          <path
            id="prefix__Shape"
            className="prefix__cls-1"
            d="M33.549 7.068v1.413a.707.707 0 01-.707.707h-1.59a6.509 6.509 0 01-.608 1.463l1.131 1.124a.707.707 0 010 1l-1 1a.707.707 0 01-1 0l-1.124-1.131a6.5 6.5 0 01-1.463.608v1.59a.707.707 0 01-.707.707h-1.413a.707.707 0 01-.707-.707v-1.59a7.329 7.329 0 01-1.463-.608l-1.124 1.131a.707.707 0 01-1 0l-1-1a.707.707 0 010-1l1.126-1.124a6.3 6.3 0 01-.6-1.463h-1.59a.707.707 0 01-.71-.707V7.068a.707.707 0 01.707-.707H20.3a6.509 6.509 0 01.6-1.461l-1.126-1.126a.707.707 0 010-1l1-1a.707.707 0 011 0L22.9 2.9a6.5 6.5 0 011.461-.6V.707A.707.707 0 0125.068 0h1.414a.707.707 0 01.707.707V2.3a7.329 7.329 0 011.463.608l1.124-1.131a.707.707 0 011 0l1 1a.707.707 0 010 1L30.644 4.9a6.3 6.3 0 01.608 1.463h1.59a.707.707 0 01.707.705z"
            transform="translate(-17.275 .725)"
          />
          <path
            id="prefix__Shape-2"
            data-name="Shape"
            d="M30.8 9.9a2.9 2.9 0 11-1.282-2.4A2.9 2.9 0 0130.8 9.9z"
            transform="translate(-19.401 -1.404)"
            fill="#cad9fc"
          />
          <path
            id="prefix__Shape-3"
            data-name="Shape"
            className="prefix__cls-1"
            d="M26.819 12.668a2.9 2.9 0 010-5.368 2.9 2.9 0 010 5.368z"
            transform="translate(-19.375 -1.484)"
          />
          <path
            id="prefix__Shape-4"
            data-name="Shape"
            className="prefix__cls-3"
            d="M28.627 7a3.627 3.627 0 102.565 1.062A3.627 3.627 0 0028.627 7zm0 5.8a2.176 2.176 0 111.539-.637 2.176 2.176 0 01-1.539.637z"
            transform="translate(-20.127 -2.127)"
          />
          <path
            id="prefix__Shape-5"
            data-name="Shape"
            className="prefix__cls-3"
            d="M33.583 10.625A1.417 1.417 0 0035 9.208V7.792a1.417 1.417 0 00-1.417-1.417h-1.076a6.041 6.041 0 00-.255-.623l.772-.793a1.417 1.417 0 000-2L32 1.976a1.417 1.417 0 00-1.962.007l-.793.765a6.843 6.843 0 00-.623-.255V1.417A1.417 1.417 0 0027.208 0h-1.416a1.417 1.417 0 00-1.417 1.417v1.076a6.843 6.843 0 00-.623.255l-.793-.772a1.417 1.417 0 00-2 0L19.976 3a1.417 1.417 0 000 2l.765.758a6.042 6.042 0 00-.255.623h-1.07A1.417 1.417 0 0018 7.792v1.416a1.417 1.417 0 001.417 1.417h1.077a6.041 6.041 0 00.255.623l-.772.793a1.417 1.417 0 000 2l1.013 1.013a1.417 1.417 0 002 0l.758-.765c.205.092.411.184.623.255v1.041A1.417 1.417 0 0025.785 17H27.2a1.417 1.417 0 001.417-1.417v-1.076c.212-.071.418-.163.623-.255l.8.772a1.417 1.417 0 002 0l1.013-1.013a1.417 1.417 0 000-2l-.765-.758a6.044 6.044 0 00.255-.623zm-2.571 3.393c-1.3-1.3-.885-.885-1.048-1.1a.708.708 0 00-.921-.17 4.958 4.958 0 01-1.31.553.708.708 0 00-.524.708v1.573h-1.417V13.99a.708.708 0 00-.524-.708 4.958 4.958 0 01-1.31-.531.708.708 0 00-.907.184 11.624 11.624 0 01-1.055 1.077l-1.013-1 .992-.97a.708.708 0 00.269-.992 5.617 5.617 0 01-.567-1.339.708.708 0 00-.666-.5h-1.594V7.792c1.608 0 1.771.071 2.054-.177s.2-.708.772-1.65a.708.708 0 00-.177-.914c-.092-.078.156.163-1.077-1.055l1-1.013.97.992a.708.708 0 001 .276 4.958 4.958 0 011.31-.553.708.708 0 00.524-.708V1.417h1.417V3.01a.708.708 0 00.524.708 4.958 4.958 0 011.31.531.708.708 0 00.907-.184 11.624 11.624 0 011.055-1.077l1.013 1-.992.97a.708.708 0 00-.276 1.006 5.752 5.752 0 01.567 1.346.708.708 0 00.708.482h1.558v1.416H31.99a.708.708 0 00-.666.5 5.334 5.334 0 01-.567 1.339.708.708 0 00.177.914c.092.078-.156-.163 1.077 1.055z"
            transform="translate(-18)"
          />
        </g>
      </svg>
    ),
    historyIcon: () => (
      <svg
        id="prefix__Component_42_94"
        data-name="Component 42 \u2013 94"
        width={17}
        height={17}
        viewBox="0 0 17 17"
      >
        <defs>
          <style>
            {
              ".prefix__cls-1{fill:#a4c2f7}.prefix__cls-2{fill:#e3e7f2}.prefix__cls-3{fill:#7facfa}.prefix__cls-5{fill:#5d61e8}"
            }
          </style>
        </defs>
        <g id="prefix__route">
          <path
            id="prefix__Path_932"
            data-name="Path 932"
            className="prefix__cls-1"
            d="M351 13.054l-1.661 1.872-1.661-1.872a2.892 2.892 0 010-3.744 2.166 2.166 0 013.322 0 2.892 2.892 0 010 3.744z"
            transform="translate(-335.459 -8.243)"
          />
          <path
            id="prefix__Path_933"
            data-name="Path 933"
            className="prefix__cls-2"
            d="M351.7 9.417a2.2 2.2 0 00-1.782-.769.318.318 0 01-.068.095c-.19.182-.369.362-.534.546a.3.3 0 01-.047.166 3.589 3.589 0 001.208 5.087l1.223-1.379a2.891 2.891 0 000-3.745z"
            transform="translate(-337.085 -8.351)"
          />
          <circle
            id="prefix__Ellipse_28"
            data-name="Ellipse 28"
            className="prefix__cls-3"
            cx={1.308}
            cy={1.308}
            transform="translate(12.642 1.453)"
            r={1.308}
          />
          <g
            id="prefix__Group_933"
            data-name="Group 933"
            transform="translate(.287 1.453)"
          >
            <ellipse
              id="prefix__Ellipse_29"
              data-name="Ellipse 29"
              className="prefix__cls-1"
              cx={0.872}
              cy={1.308}
              rx={0.872}
              ry={1.308}
              transform="translate(12.494)"
            />
            <path
              id="prefix__Path_934"
              data-name="Path 934"
              className="prefix__cls-1"
              d="M18.2 228.031l-2.26 2.553-2.26-2.553a3.95 3.95 0 010-5.106 2.944 2.944 0 014.52 0 3.95 3.95 0 010 5.106z"
              transform="translate(-12.742 -216.199)"
            />
          </g>
          <path
            id="prefix__Path_935"
            data-name="Path 935"
            className="prefix__cls-2"
            d="M15.283 223a2.984 2.984 0 00-2.56-1.041.26.26 0 01-.2.384 1.805 1.805 0 00-.223.053.321.321 0 01-.074.2 4.916 4.916 0 01-1.077.86 4.876 4.876 0 00-.289 1.873c-.015.187-.191.716-.236 1.093.111.224.233.447.354.667.629 1.149 1.809 2.037 2.355 3.213l1.948-2.2a3.95 3.95 0 00.002-5.102z"
            transform="translate(-10.411 -214.822)"
          />
          <circle
            id="prefix__Ellipse_30"
            data-name="Ellipse 30"
            className="prefix__cls-3"
            cx={1.453}
            cy={1.453}
            transform="translate(2.03 9.02)"
            r={1.453}
          />
          <ellipse
            id="prefix__Ellipse_31"
            data-name="Ellipse 31"
            className="prefix__cls-1"
            cx={1.017}
            cy={1.453}
            rx={1.017}
            ry={1.453}
            transform="translate(2.03 9.02)"
          />
          <path
            id="prefix__Path_936"
            data-name="Path 936"
            d="M11.208 230.2l.073-.073a.306.306 0 01.14-.082c.007 0 .012-.011.02-.016a.96.96 0 01.159-.067.283.283 0 01.094-.053.26.26 0 01.061-.04l-1.471-1.662a3.949 3.949 0 010-5.106 3.056 3.056 0 011.821-1.02 2.97 2.97 0 00-2.692 1.02 3.949 3.949 0 000 5.106l1.78 2.011c.007 0 .007-.007.015-.018z"
            transform="translate(-8.335 -214.928)"
            fill="#fff"
          />
          <g id="prefix__Group_934" data-name="Group 934">
            <path
              id="prefix__Path_937"
              data-name="Path 937"
              className="prefix__cls-5"
              d="M7.807 222.632a.292.292 0 01-.218-.1l-2.26-2.553a4.253 4.253 0 010-5.491 3.234 3.234 0 014.955 0 4.253 4.253 0 010 5.491l-2.26 2.553a.292.292 0 01-.218.1zm0-8.717a2.716 2.716 0 00-2.042.96 3.655 3.655 0 000 4.721l2.042 2.304 2.043-2.3a3.655 3.655 0 000-4.721 2.716 2.716 0 00-2.043-.964z"
              transform="translate(-4.325 -206.503)"
            />
            <path
              id="prefix__Path_938"
              data-name="Path 938"
              className="prefix__cls-5"
              d="M341.19 6.973a.29.29 0 01-.217-.1L339.311 5a3.193 3.193 0 010-4.13 2.457 2.457 0 013.757 0 3.193 3.193 0 010 4.13l-1.661 1.872a.29.29 0 01-.217.101zm0-6.392a1.922 1.922 0 00-1.443.678 2.6 2.6 0 000 3.359l1.444 1.627 1.443-1.627a2.6 2.6 0 000-3.359 1.922 1.922 0 00-1.444-.678z"
              transform="translate(-327.312)"
            />
            <path
              id="prefix__Path_939"
              data-name="Path 939"
              className="prefix__cls-5"
              d="M108.681 198.775H98.367a.291.291 0 010-.581h10.315a1.017 1.017 0 100-2.034h-3.487a1.6 1.6 0 010-3.2h5.23a1.017 1.017 0 100-2.034h-6.392a1.6 1.6 0 010-3.2h3.341a.291.291 0 010 .581h-3.341a1.017 1.017 0 100 2.034h6.392a1.6 1.6 0 110 3.2h-5.23a1.017 1.017 0 100 2.034h3.487a1.6 1.6 0 010 3.2z"
              transform="translate(-95.023 -181.775)"
            />
            <path
              id="prefix__Path_940"
              data-name="Path 940"
              className="prefix__cls-5"
              d="M372.741 37.33a1.6 1.6 0 111.6-1.6 1.6 1.6 0 01-1.6 1.6zm0-2.615a1.017 1.017 0 101.017 1.017 1.017 1.017 0 00-1.017-1.017z"
              transform="translate(-358.792 -32.972)"
            />
            <path
              id="prefix__Path_941"
              data-name="Path 941"
              className="prefix__cls-5"
              d="M57.152 268.02a1.743 1.743 0 111.743-1.743 1.743 1.743 0 01-1.743 1.743zm0-2.906a1.162 1.162 0 101.162 1.162 1.162 1.162 0 00-1.162-1.162z"
              transform="translate(-53.67 -255.806)"
            />
          </g>
        </g>
      </svg>
    ),
    alertIcon: () => (
      <svg
        id="prefix__Component_43_94"
        dataName="Component 43 \u2013 94"
        width={16.775}
        height={19.086}
        viewBox="0 0 16.775 19.086"
      >
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={-0.236}
            y1={1.489}
            x2={-0.234}
            y2={1.487}
            gradientUnits="objectBoundingBox"
          >
            <stop offset={0} stopColor="#d4e1f4" />
            <stop offset={0.172} stopColor="#d4e1f4" />
            <stop offset={0.2} stopColor="#d4e1f4" />
            <stop offset={0.2} stopColor="#dae4f4" />
            <stop offset={0.201} stopColor="#ebebf4" />
            <stop offset={0.201} stopColor="#f6f1f4" />
            <stop offset={0.202} stopColor="#fdf4f4" />
            <stop offset={0.205} stopColor="#fff5f4" />
            <stop offset={0.252} stopColor="#fff5f4" />
            <stop offset={0.26} stopColor="#fff5f4" />
            <stop offset={0.26} stopColor="#d4e1f4" />
            <stop offset={0.397} stopColor="#d4e1f4" />
            <stop offset={0.42} stopColor="#d4e1f4" />
            <stop offset={0.42} stopColor="#dae4f4" />
            <stop offset={0.421} stopColor="#ebebf4" />
            <stop offset={0.421} stopColor="#f6f1f4" />
            <stop offset={0.422} stopColor="#fdf4f4" />
            <stop offset={0.425} stopColor="#fff5f4" />
            <stop offset={0.489} stopColor="#fff5f4" />
            <stop offset={0.5} stopColor="#fff5f4" />
            <stop offset={0.5} stopColor="#f9f2f4" />
            <stop offset={0.5} stopColor="#e8ebf4" />
            <stop offset={0.5} stopColor="#dde5f4" />
            <stop offset={0.501} stopColor="#d6e2f4" />
            <stop offset={0.501} stopColor="#d4e1f4" />
            <stop offset={0.706} stopColor="#d4e1f4" />
            <stop offset={0.74} stopColor="#d4e1f4" />
            <stop offset={0.741} stopColor="#fff5f4" />
            <stop offset={0.835} stopColor="#fff5f4" />
            <stop offset={0.85} stopColor="#fff5f4" />
            <stop offset={0.851} stopColor="#d4e1f4" />
          </linearGradient>
          <style>
            {".prefix__cls-1{fill:#a4c2f7}.prefix__cls-4{fill:#5d61e8}"}
          </style>
        </defs>
        <g id="prefix__bell">
          <g
            id="prefix__Group_935"
            dataName="Group 935"
            transform="translate(.347 2.076)"
          >
            <path
              id="prefix__Path_942"
              dataName="Path 942"
              className="prefix__cls-1"
              d="M179.059 451.092a3.107 3.107 0 005.745 0 21.2 21.2 0 01-5.745 0z"
              transform="translate(-173.887 -436.352)"
            />
            <path
              id="prefix__Path_943"
              dataName="Path 943"
              className="prefix__cls-1"
              d="M43.6 70.154a23.675 23.675 0 009.494 0l3.293-.569a8.151 8.151 0 01-2.539-5.9v-3.122a4.722 4.722 0 00-2.757-4.268 6.6 6.6 0 00-5.485 0 4.879 4.879 0 00-2.871 4.266v3.123a8.046 8.046 0 01-2.429 5.9z"
              transform="translate(-40.303 -55.699)"
            />
          </g>
          <path
            id="prefix__Path_944"
            dataName="Path 944"
            d="M50.369 70.155a17.223 17.223 0 008.082 0l3.293-.569a8.151 8.151 0 01-2.539-5.9v-3.122a4.722 4.722 0 00-2.757-4.264 3.773 3.773 0 00-4.073 0 4.879 4.879 0 00-2.875 4.264v3.123a8.046 8.046 0 01-2.429 5.9z"
            transform="translate(-46.475 -53.624)"
            fill="url(#prefix__linear-gradient)"
          />
          <path
            id="prefix__Path_945"
            dataName="Path 945"
            d="M44 60.752v3.123a8.151 8.151 0 01-2.539 5.9l.142.025a.431.431 0 00-.046.192l-1.257-.217a8.151 8.151 0 002.539-5.9v-3.123a4.723 4.723 0 012.761-4.268 6.6 6.6 0 012.96-.584 5.685 5.685 0 00-1.8.584A4.723 4.723 0 0044 60.752z"
            transform="translate(-39.955 -53.812)"
            fill="#fff"
          />
          <g id="prefix__Group_936" data-name="Group 936">
            <path
              id="prefix__Path_946"
              dataName="Path 946"
              className="prefix__cls-4"
              d="M39.38 61.936a27.613 27.613 0 01-4.806-.488l-3.294-.569a.347.347 0 01-.186-.588 7.7 7.7 0 002.327-5.653v-3.124a5.25 5.25 0 013.072-4.581 6.913 6.913 0 015.775 0 5.049 5.049 0 012.96 4.586v3.121a7.758 7.758 0 002.437 5.653.347.347 0 01-.186.588l-3.293.569a27.611 27.611 0 01-4.806.488zm-4.688-1.172a23.311 23.311 0 009.376 0l2.657-.459a8.445 8.445 0 01-2.191-5.667v-3.124a4.405 4.405 0 00-2.554-3.953 6.221 6.221 0 00-5.2 0 4.543 4.543 0 00-2.669 3.953v3.121a8.351 8.351 0 01-2.078 5.665z"
              transform="translate(-30.993 -44.574)"
            />
            <path
              id="prefix__Path_947"
              dataName="Path 947"
              className="prefix__cls-4"
              d="M143.049 96.989a.347.347 0 01-.345-.349 3.507 3.507 0 012.064-3 5.3 5.3 0 014.327 0 .347.347 0 11-.289.631 4.593 4.593 0 00-3.748 0 2.8 2.8 0 00-1.661 2.377.347.347 0 01-.347.345z"
              transform="translate(-138.538 -89.702)"
            />
            <path
              id="prefix__Path_948"
              dataName="Path 948"
              className="prefix__cls-4"
              d="M208.213 2.586a.347.347 0 01-.347-.347v-.5a1.735 1.735 0 013.47 0v.479a.347.347 0 01-.417.34 6.311 6.311 0 00-2.63.024.34.34 0 01-.076.008zM209.6.694a1.042 1.042 0 00-1.041 1.041v.085a7.051 7.051 0 012.082-.018v-.067A1.042 1.042 0 00209.6.694z"
              transform="translate(-201.273)"
            />
            <path
              id="prefix__Path_949"
              dataName="Path 949"
              className="prefix__cls-4"
              d="M172.968 444.406a3.516 3.516 0 01-3.19-2.129.347.347 0 01.361-.485 20.758 20.758 0 005.658 0 .351.351 0 01.322.137.347.347 0 01.039.348 3.516 3.516 0 01-3.19 2.13zm-2.228-1.846a2.731 2.731 0 004.457 0 20.756 20.756 0 01-4.457 0z"
              transform="translate(-164.576 -425.32)"
            />
          </g>
        </g>
      </svg>
    ),
    gpsOn: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(1640 6164)">
          <g transform="translate(-1635 -6160)">
            <path
              fill="#09f"
              d="M.909 7.115A11.639 11.639 0 017.055.916 11.393 11.393 0 0111.55 0a1.64 1.64 0 010 3.281 8.342 8.342 0 00-8.3 8.368 1.635 1.635 0 01-1.623 1.641A1.635 1.635 0 010 11.65a11.665 11.665 0 01.909-4.535zm0 0"
              transform="translate(-.001 -.001)"
            />
            <path
              fill="#09f"
              d="M6.588 192.8a1.641 1.641 0 010 3.281 3.353 3.353 0 00-3.335 3.364 1.635 1.635 0 01-1.626 1.64A1.635 1.635 0 010 199.446a6.63 6.63 0 011.93-4.7 6.516 6.516 0 014.658-1.946zm0 0"
              transform="translate(4.961 -187.797)"
            />
            <path
              fill="#09f"
              d="M1.626 385.6a1.641 1.641 0 010 3.281 1.641 1.641 0 010-3.281zm0 0"
              transform="translate(9.923 -375.593)"
            />
          </g>
          <g transform="translate(-1640 -6164)" stroke="#09f" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
        </g>
      </svg>
    ),
    gpsOff: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(.107)">
          <g transform="translate(-.107)" stroke="#707070" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
          <g transform="translate(4.117 4.6)">
            <path
              fill="#707070"
              d="M.911 7.131A11.664 11.664 0 017.07.918 11.417 11.417 0 0111.575 0a1.644 1.644 0 010 3.288 8.36 8.36 0 00-8.314 8.386 1.639 1.639 0 01-1.63 1.644A1.639 1.639 0 010 11.675 11.689 11.689 0 01.91 7.13zm.72 5.408a.861.861 0 00.856-.864 9.18 9.18 0 012.662-6.482 9.055 9.055 0 012.889-1.964 8.965 8.965 0 013.538-.72.864.864 0 000-1.727A10.86 10.86 0 00.775 11.675a.861.861 0 00.856.864zm0 0"
              transform="translate(-.001 -.001)"
            />
            <path
              fill="#707070"
              d="M6.6 192.8a1.644 1.644 0 010 3.288 3.361 3.361 0 00-3.34 3.372 1.639 1.639 0 01-1.63 1.64A1.639 1.639 0 010 199.46a6.645 6.645 0 011.934-4.709A6.53 6.53 0 016.6 192.8zm-4.97 7.524a.861.861 0 00.856-.864 4.139 4.139 0 014.114-4.151.864.864 0 000-1.727 5.86 5.86 0 00-5.826 5.878.861.861 0 00.856.864zm0 0"
              transform="translate(4.972 -187.786)"
            />
            <path
              fill="#707070"
              d="M1.63 385.6a1.644 1.644 0 010 3.288 1.644 1.644 0 010-3.288zm0 2.508a.864.864 0 10-.856-.864.861.861 0 00.856.862zm0 0"
              transform="translate(9.944 -375.568)"
            />
          </g>
        </g>
      </svg>
    ),
    doorOff: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(1176 -4308)">
          <g transform="translate(-1170.48 4311.68)">
            <path
              fill="#707070"
              d="M75.251 7.684l-1.643-2.737a.309.309 0 00.118-.24V2.2a.314.314 0 00-.314-.314h-.044a1.562 1.562 0 00-.654-.948L71.706.264a1.565 1.565 0 00-.87-.264h-2.378a1.567 1.567 0 00-.87.264L66.58.935a1.562 1.562 0 00-.654.948h-.044a.314.314 0 00-.314.314v2.51a.308.308 0 00.118.24l-1.643 2.737a.314.314 0 10.538.322l1.3-2.167v4.2a.314.314 0 00-.314.314v2.51a.314.314 0 00.314.314h.032a2.193 2.193 0 002.165 1.883h3.138a2.193 2.193 0 002.165-1.883h.032a.314.314 0 00.314-.314v-2.51a.314.314 0 00-.314-.314V5.84l1.3 2.167a.314.314 0 10.538-.322zm-8.742-2.219l.628.628v2.814l-.628.314zm6.276 3.755l-.628-.314V6.092l.628-.628zm0-4.643L71.622 5.74a.314.314 0 00-.092.222V9.1a.314.314 0 00.173.281l1.082.541v2.944a1.571 1.571 0 01-1.569 1.569h-3.138a1.571 1.571 0 01-1.569-1.569V9.922l1.082-.541a.314.314 0 00.173-.281V5.962a.314.314 0 00-.092-.222l-1.163-1.163V2.241a.939.939 0 01.419-.783l1.007-.672a.94.94 0 01.522-.158h2.378a.938.938 0 01.522.158l1.008.672a.939.939 0 01.419.783z"
              transform="translate(-63.998)"
            />
            <path
              fill="#707070"
              d="M181.779 106.965a.624.624 0 00-.534-.3h-3.378a.628.628 0 00-.561.908l.628 1.255a.624.624 0 00.561.347h2.122a.624.624 0 00.561-.347l.628-1.255a.623.623 0 00-.027-.608zm-1.161 1.585H178.5l-.628-1.255h3.378z"
              transform="translate(-173.908 -103.529)"
            />
            <path
              fill="#707070"
              d="M175.655 342.764l-.628-1.255a.314.314 0 00-.421-.14 3.487 3.487 0 01-1.429.281 3.545 3.545 0 01-1.43-.281.316.316 0 00-.42.141l-.628 1.255a.314.314 0 00.059.362 4.424 4.424 0 004.837 0 .314.314 0 00.06-.363zm-2.477.454a3.479 3.479 0 01-1.8-.411l.38-.761a4.482 4.482 0 002.834 0l.38.761a3.48 3.48 0 01-1.795.412z"
              transform="translate(-167.529 -331.294)"
            />
          </g>
          <g transform="translate(-1176 4308)" stroke="#707070" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
        </g>
      </svg>
    ),
    doorOn: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g stroke="#09f" fill="none">
          <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
          <circle cx={11.5} cy={11.5} r={11} />
        </g>
        <path
          d="M17.253 11.683l-1.642-2.737a.308.308 0 00.118-.24V6.2a.314.314 0 00-.314-.314h-.044a1.562 1.562 0 00-.654-.947l-1.009-.676a1.566 1.566 0 00-.87-.263H10.46a1.567 1.567 0 00-.87.263l-1.008.672a1.562 1.562 0 00-.654.947h-.045a.314.314 0 00-.314.314v2.51a.308.308 0 00.118.24l-1.642 2.737a.314.314 0 10.538.322l1.3-2.166v4.2a.314.314 0 00-.314.314v2.51a.314.314 0 00.314.314h.032a2.193 2.193 0 002.165 1.883h3.138a2.193 2.193 0 002.165-1.883h.032a.314.314 0 00.314-.314v-2.51a.314.314 0 00-.314-.314v-4.2l1.3 2.166a.314.314 0 10.538-.322zM9.426 7.435a.624.624 0 01.534-.3h3.378a.628.628 0 01.561.908L13.272 9.3a.624.624 0 01-.561.347h-2.123a.624.624 0 01-.561-.347l-.624-1.254a.623.623 0 01.023-.611zm-.915 5.783V9.464l.628.628v2.813zm5.557 2.612a4.425 4.425 0 01-4.837 0 .314.314 0 01-.059-.362l.628-1.255a.316.316 0 01.42-.141 3.545 3.545 0 001.43.281 3.489 3.489 0 001.429-.281.314.314 0 01.421.14l.628 1.255a.314.314 0 01-.06.364zm.72-2.612l-.628-.314v-2.813l.628-.628z"
          fill="#09f"
        />
      </svg>
    ),
    ignitionOn: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g stroke="#09f" fill="none">
          <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
          <circle cx={11.5} cy={11.5} r={11} />
        </g>
        <path
          d="M5.1 15.573l4.022-4.039-.1-.1a.328.328 0 01.11-.537l.473-.19-.444-.444a1.915 1.915 0 010-2.7l2.021-2.03a1.972 1.972 0 012.7 0l3.658 3.665a1.915 1.915 0 010 2.7l-2.022 2.03a1.906 1.906 0 01-2.7 0l-.448-.449-.189.474a.327.327 0 01-.536.11l-.1-.1-1.729 1.742a.327.327 0 01-.232.1h-.327a.328.328 0 01-.327.328h-.655v.656a.328.328 0 01-.327.328v.328a.328.328 0 01-.1.232l-.327.328a.327.327 0 01-.232.1H5.327A.328.328 0 015 17.773v-1.972a.328.328 0 01.1-.228zm6.713-6.59l2.287 2.29a1.023 1.023 0 001.445-1.448l-2.292-2.3a1.025 1.025 0 00-1.444 1.454z"
          fill="#09f"
        />
      </svg>
    ),
    ignitionOff: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23"}
        height={height ? height : "23"}
        viewBox="0 0 23 23"
      >
        <g transform="translate(1191 -4263)">
          <g transform="translate(-1191 4263)" stroke="#707070" fill="none">
            <circle cx={11.5} cy={11.5} r={11.5} stroke="none" />
            <circle cx={11.5} cy={11.5} r={11} />
          </g>
          <g transform="translate(-1186.4 4267.6)">
            <path
              fill="#707070"
              d="M.1 11.3l4.3-4.314-.1-.1a.351.351 0 01.118-.574l.506-.2-.479-.48a2.048 2.048 0 010-2.892L6.609.571a2.108 2.108 0 012.885 0l3.906 3.92a2.048 2.048 0 010 2.892l-2.156 2.165a2.037 2.037 0 01-2.885 0l-.479-.48-.2.507a.35.35 0 01-.573.118L7 9.59l-1.852 1.858a.349.349 0 01-.248.1h-.35a.35.35 0 01-.35.351h-.7v.7a.35.35 0 01-.35.351v.35a.351.351 0 01-.1.248l-.35.352a.349.349 0 01-.248.1H.35a.35.35 0 01-.35-.344V11.55a.351.351 0 01.1-.25zm8.754-2.238a1.386 1.386 0 001.9 0L12.91 6.9a1.341 1.341 0 000-1.9L9 1.093a1.34 1.34 0 00-1.9 0L4.943 3.254a1.341 1.341 0 000 1.9zM.7 13.306h1.606l.145-.145v-.555a.35.35 0 01.35-.35v-.7a.35.35 0 01.35-.35h.7a.35.35 0 01.35-.35h.555l2-2a.349.349 0 01.469-.024l.117-.293-1.876-1.876-.293.117a.35.35 0 01-.024.469L.7 11.7z"
            />
            <path
              fill="#707070"
              d="M73.713 73.711a1.108 1.108 0 011.557 0l2.469 2.451a1.089 1.089 0 010 1.546 1.107 1.107 0 01-1.557 0l-2.469-2.451a1.089 1.089 0 010-1.546zm.5 1.05l2.469 2.451a.407.407 0 00.559 0 .391.391 0 000-.555l-2.469-2.451a.4.4 0 00-.559 0 .391.391 0 000 .555z"
              transform="translate(-66.457 -70.982)"
            />
          </g>
        </g>
      </svg>
    ),
    vehicles: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-.77.77c-.28.28-.28.72 0 1s.72.28 1 0L7 18h2v-5H4.5c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5V8h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.24c0 .55.45.99 1 .99s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s.99-.44 1-.99L22 13.77l-1.43-4.11zm-7.8.34h6.48c.21 0 .4.14.47.34l.69 2c.11.32-.13.66-.47.66h-7.85c-.34 0-.58-.34-.47-.66l.69-2c.05-.2.24-.34.46-.34zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        />
      </svg>
    ),
    addRecord: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <g>
          <rect fill="none" height="24" width="24" />
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <g />
          <g>
            <path
              fill={fill ? fill : "#000"}
              d="M18,12c-0.55,0-1,0.45-1,1v5.22c0,0.55-0.45,1-1,1H6c-0.55,0-1-0.45-1-1V8c0-0.55,0.45-1,1-1h5c0.55,0,1-0.45,1-1 c0-0.55-0.45-1-1-1H5C3.9,5,3,5.9,3,7v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-6C19,12.45,18.55,12,18,12z"
            />
            <path
              fill={fill ? fill : "#000"}
              d="M21.02,5H19V2.98C19,2.44,18.56,2,18.02,2h-0.03C17.44,2,17,2.44,17,2.98V5h-2.01C14.45,5,14.01,5.44,14,5.98 c0,0.01,0,0.02,0,0.03C14,6.56,14.44,7,14.99,7H17v2.01c0,0.54,0.44,0.99,0.99,0.98c0.01,0,0.02,0,0.03,0 c0.54,0,0.98-0.44,0.98-0.98V7h2.02C21.56,7,22,6.56,22,6.02V5.98C22,5.44,21.56,5,21.02,5z"
            />
            <path
              fill={fill ? fill : "#000"}
              d="M14,9H8c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1C15,9.45,14.55,9,14,9z"
            />
            <path
              fill={fill ? fill : "#000"}
              d="M14,12H8c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1C15,12.45,14.55,12,14,12z"
            />
            <path
              fill={fill ? fill : "#000"}
              d="M14,15H8c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1C15,15.45,14.55,15,14,15z"
            />
          </g>
        </g>
      </svg>
    ),
    tempScale: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "15.753"}
        height={height ? height : "17.185"}
        viewBox="0 0 15.753 17.185"
      >
        <path
          fill="red"
          d="M7.16 1.79a1.79 1.79 0 00-3.58 0v11.146a2.506 2.506 0 103.58 0zM5.37 16.469a1.792 1.792 0 01-1.79-1.79 1.766 1.766 0 01.6-1.325.359.359 0 00.118-.266V1.79a1.074 1.074 0 012.148 0v11.3a.359.359 0 00.118.266 1.766 1.766 0 01.6 1.325 1.792 1.792 0 01-1.794 1.788z"
        />
        <path
          fill="red"
          d="M5.728 13.67V7.518a.358.358 0 00-.716 0v6.152a1.074 1.074 0 10.716 0zm-.358 1.366a.358.358 0 11.358-.358.358.358 0 01-.358.359zM2.506 11.457H.358a.358.358 0 100 .716h2.148a.358.358 0 100-.716zM2.506 10.025H1.79a.358.358 0 100 .716h.716a.358.358 0 100-.716zM2.506 8.593H1.79a.358.358 0 000 .716h.716a.358.358 0 000-.716zM.358 7.876h2.148a.358.358 0 100-.716H.358a.358.358 0 100 .716zM.358 3.58h2.148a.358.358 0 000-.716H.358a.358.358 0 000 .716zM2.506 5.728H1.79a.358.358 0 100 .716h.716a.358.358 0 100-.716zM2.506 4.296H1.79a.358.358 0 100 .716h.716a.358.358 0 100-.716zM10.383 5.728h.716a1.075 1.075 0 011.074 1.074.358.358 0 10.716 0 1.792 1.792 0 00-1.79-1.79h-.716a1.792 1.792 0 00-1.79 1.79v2.864a1.792 1.792 0 001.79 1.79h.716a1.792 1.792 0 001.79-1.79.358.358 0 10-.716 0 1.075 1.075 0 01-1.074 1.074h-.716a1.075 1.075 0 01-1.074-1.074V6.802a1.075 1.075 0 011.074-1.074zM14.679 5.012a1.074 1.074 0 101.074 1.074 1.075 1.075 0 00-1.074-1.074zm0 1.432a.358.358 0 11.358-.358.358.358 0 01-.358.358z"
        />
      </svg>
    ),
    fuelPump: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "20.172"}
        height={height ? height : "20.251"}
        viewBox="0 0 20.172 20.251"
      >
        <g opacity={0.8}>
          <path
            fill="#ffc400"
            d="M4.153 7.159h7.12a.593.593 0 00.593-.593v-3.56a.593.593 0 00-.593-.593h-7.12a.593.593 0 00-.593.593v3.56a.593.593 0 00.593.593zm.593-3.56h5.934v2.374H4.747zM8.249 11.058a.594.594 0 00-1.066-.015c-.28.553-1.275 1.533-1.275 2.661a1.804 1.804 0 003.608 0c0-1.128-1.014-2.111-1.267-2.646zm-.536 3.25a.579.579 0 01-.617-.6 2.746 2.746 0 01.613-1.306 2.778 2.778 0 01.622 1.306.579.579 0 01-.615.6z"
          />
          <path
            fill="#ffc400"
            d="M19.115 4.357l-2.767-1.845a.593.593 0 10-.658.987l.922.615v4.825a.593.593 0 00.593.593h1.78v4.746a1.187 1.187 0 01-2.373 0V12.5a1.782 1.782 0 00-1.78-1.78h-.593V1.78A1.782 1.782 0 0012.459 0H2.967a1.782 1.782 0 00-1.78 1.78v14.872H.593a.593.593 0 00-.593.593v2.413a.593.593 0 00.593.593h14.24a.593.593 0 00.593-.593v-2.413a.593.593 0 00-.593-.593h-.593v-4.746h.593a.594.594 0 01.593.593v1.78a2.373 2.373 0 104.746 0V6.332a2.368 2.368 0 00-1.057-1.975zM2.967 1.187h9.493a.594.594 0 01.593.593v6.526H2.373V1.78a.594.594 0 01.594-.593zm11.272 17.878H1.187v-1.226h13.052zM2.373 16.652V9.493h10.68v7.159zM17.8 8.346v-3.44l.658.439a1.184 1.184 0 01.528.987v2.014z"
          />
        </g>
      </svg>
    ),
    manIcon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "23.793"}
        height={height ? height : "27.655"}
        viewBox="0 0 23.793 27.655"
      >
        <path
          fill="#0ed8f8"
          stroke="#0ed8f8"
          strokeWidth=".5px"
          d="M20.68 15.776l-5.047-2.489a4.111 4.111 0 001.407-1.81l1.31-.634a1.359 1.359 0 00.825-1.222v-.317a1.384 1.384 0 00-1.455-1.355h-.485V6.32l1.6-1.9a1.3 1.3 0 00-.243-1.9.8.8 0 00-.342-.177L14.129.709a6.242 6.242 0 00-4.61 0L5.394 2.343a1.335 1.335 0 00-.776 1.765 1.117 1.117 0 00.194.317l1.6 1.9v1.624h-.485a1.384 1.384 0 00-1.456 1.357v.362a1.329 1.329 0 00.825 1.222l1.31.633a3.521 3.521 0 001.407 1.81l-5.047 2.489A4.852 4.852 0 00.25 20.165v7.24h23.293v-7.24a4.852 4.852 0 00-2.863-4.389zm-3.251-.588L14.42 17.27l-1.65-2.172a1.493 1.493 0 00.534-.271l1.456-.95zm-4.125 2.172l-.679 1h-1.408l-.728-1 1.407-1.855zm4.416-8.506a.444.444 0 01.485.452v.362a.435.435 0 01-.291.407l-.679.317V8.854zM5.879 10.075a.52.52 0 01-.291-.407v-.362a.444.444 0 01.485-.452h.485v1.538zm-.194-6.244a.428.428 0 01.1-.633c.049-.045.049-.045.1-.045l4.125-1.629a5.108 5.108 0 013.834 0l4.125 1.629a.438.438 0 01.243.588.155.155 0 01-.049.09l-1.65 1.855h-9.22zm10.045 2.76l-.146.181a3.509 3.509 0 01-2.62 1.176h-2.232a3.4 3.4 0 01-2.766-1.357zm-8.2 3.8V7.587a4.53 4.53 0 003.154 1.267h2.232a4.5 4.5 0 003.3-1.448v2.937a2.64 2.64 0 01-1.266 2.221l-2.281 1.493a1.551 1.551 0 01-1.65 0l-2.281-1.493a2.692 2.692 0 01-1.209-2.172zm1.5 3.484l1.456.95a5.422 5.422 0 00.534.271l-1.65 2.172-3.009-2.081zM6.07 26.499H1.221v-6.334a4.07 4.07 0 012.329-3.622l1.893-.95 1.213.86 2.232 10.045zm1.747-9.185l1.747 1.222.291-.407.534.769-1.019 5.565zM10.05 26.5l1.31-7.24h1.116l1.31 7.24zm3.348-7.6l.534-.769.291.407 1.747-1.222-1.6 7.194zm9.172 7.6h-7.665l2.232-10 1.213-.857 1.893.95a4.107 4.107 0 012.329 3.62z"
        />
        <path
          fill="#0ed8f8"
          stroke="#0ed8f8"
          strokeWidth=".5px"
          d="M12.783 2.761h-1.818a1.882 1.882 0 000 3.763h1.818a1.882 1.882 0 100-3.763zm.5 2.258a.57.57 0 01-.5.251h-1.818a.627.627 0 110-1.254h1.818a.593.593 0 01.627.627.461.461 0 01-.127.376z"
        />
      </svg>
    ),
    speedIcon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "14.842"}
        height={height ? height : "13.679"}
        viewBox="0 0 14.842 13.679"
      >
        <g transform="translate(.15 .15)">
          <path
            fill="#ff6f00"
            stroke="#ff6f00"
            strokeWidth="0.3px"
            d="M12.413 18.008a7.368 7.368 0 00-10.283 0 7.049 7.049 0 00.327 10.4.219.219 0 00.3-.018.209.209 0 00-.019-.3 6.63 6.63 0 01-.308-9.779 6.93 6.93 0 019.672 0 6.63 6.63 0 01-.308 9.779.209.209 0 00-.019.3.219.219 0 00.3.018 7.049 7.049 0 00.327-10.4z"
            transform="translate(0 -15.917)"
          />
          <g transform="translate(3.748 11.471)">
            <path
              fill="#ff6f00"
              stroke="#ff6f00"
              strokeWidth="0.3px"
              d="M134.587 426.923h-4.7a.21.21 0 100 .419h4.7a.3.3 0 01.3.3v.469a.3.3 0 01-.3.3h-5.608a.3.3 0 01-.3-.3v-.469a.3.3 0 01.3-.3h.208a.21.21 0 100-.419h-.208a.72.72 0 00-.719.719v.469a.72.72 0 00.719.719h5.608a.72.72 0 00.719-.719v-.469a.72.72 0 00-.719-.719z"
              transform="translate(-128.259 -426.923)"
            />
          </g>
          <g transform="translate(1.575 1.122)">
            <path
              fill="#ff6f00"
              stroke="#ff6f00"
              strokeWidth="0.3px"
              d="M66.142 57.779a5.941 5.941 0 00-9.028 2.437.21.21 0 00.368.2 4.862 4.862 0 017.261-.951.21.21 0 00.278-.315 5.283 5.283 0 00-6.43-.429 5.524 5.524 0 017.3-.606.21.21 0 10.252-.336z"
              transform="translate(-57.097 -56.596)"
            />
          </g>
          <g transform="translate(10.695 3.331)">
            <path
              fill="#ff6f00"
              stroke="#ff6f00"
              strokeWidth="0.3px"
              d="M373.961 135.032a.21.21 0 10-.328.261 5.455 5.455 0 011.2 3.228h-1.349a5.229 5.229 0 00-.558-1.691.21.21 0 00-.37.2 4.816 4.816 0 01.536 1.728.21.21 0 00.208.186h1.746a.21.21 0 00.21-.21 5.876 5.876 0 00-1.295-3.702z"
              transform="translate(-372.528 -134.953)"
            />
          </g>
          <g transform="translate(6.474 2.436)">
            <path
              fill="#ff6f00"
              stroke="#ff6f00"
              strokeWidth="0.3px"
              d="M229.242 102.25a.21.21 0 00-.28.045l-3.639 4.6a.21.21 0 00.329.26l2.171-2.743-2.454 4.57c-.019.03-.05.08-.066.1a.461.461 0 11-.721-.575l.656-.829a.21.21 0 00-.329-.26l-.656.828a.881.881 0 00.687 1.43.9.9 0 00.1-.006.875.875 0 00.59-.327 1.733 1.733 0 00.1-.148l.005-.009 3.576-6.659a.21.21 0 00-.069-.277z"
              transform="translate(-224.061 -102.216)"
            />
          </g>
          <g transform="translate(7.09 8.799)">
            <path
              fill="#ff6f00"
              stroke="#ff6f00"
              strokeWidth="0.3px"
              d="M249.8 331.686a.21.21 0 10-.032.27.211.211 0 00.032-.27z"
              transform="translate(-249.416 -331.595)"
            />
          </g>
        </g>
      </svg>
    ),
    distanceIcon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "15.027"}
        height={height ? height : "15.092"}
        viewBox="0 0 15.027 15.092"
      >
        <g transform="translate(-.172 .15)">
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M5.564 25.98a2.791 2.791 0 00-2.1-.98 2.79 2.79 0 00-2.1.98 3.608 3.608 0 000 4.659l2.1 2.375 2.1-2.375a3.608 3.608 0 000-4.659zM5.2 30.313l-1.738 1.958-1.733-1.958a3.1 3.1 0 010-4.005 2.3 2.3 0 011.733-.814 2.3 2.3 0 011.733.814 3.1 3.1 0 01.005 4.005z"
            transform="translate(0 -18.837)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M41.91 6.042l1.594-1.8a2.709 2.709 0 000-3.5 2.085 2.085 0 00-3.187 0 2.709 2.709 0 000 3.5zm-1.225-4.974a1.592 1.592 0 012.45 0 2.2 2.2 0 010 2.85L41.91 5.3l-1.225-1.382a2.2 2.2 0 010-2.85z"
            transform="translate(-29.511)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M51.043 54.5a.246.246 0 00-.295.186.855.855 0 01-.163.343.247.247 0 10.388.3 1.359 1.359 0 00.257-.539.247.247 0 00-.187-.29z"
            transform="translate(-37.692 -41.058)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M30.03 30.778a.867.867 0 01-.309-.057.247.247 0 00-.176.461 1.361 1.361 0 00.484.089h.088a.247.247 0 100-.493z"
            transform="translate(-21.76 -23.135)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M28.866 22.681a.247.247 0 00.13-.037.851.851 0 01.358-.124.247.247 0 10-.054-.49 1.337 1.337 0 00-.566.2.247.247 0 00.131.456z"
            transform="translate(-21.182 -16.597)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M15.8 58h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-10.968 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M35.078 40h-.063a.247.247 0 00.01.493h.493a.247.247 0 000-.493z"
            transform="translate(-25.822 -30.139)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M34.74 22.493h.493a.247.247 0 100-.493h-.493a.247.247 0 100 .493z"
            transform="translate(-25.607 -16.576)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M47.025 40a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-34.864 -30.139)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M48.337 31.247a.246.246 0 00-.246-.247H47.6a.247.247 0 100 .493h.493a.246.246 0 00.244-.246z"
            transform="translate(-35.295 -23.357)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M41.025 40.493h.493a.247.247 0 000-.493h-.493a.247.247 0 000 .493z"
            transform="translate(-30.343 -30.139)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M41.233 22.493a.247.247 0 000-.493h-.493a.247.247 0 100 .493z"
            transform="translate(-30.128 -16.576)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M35.6 31a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-26.254 -23.357)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M42.337 31.247a.246.246 0 00-.246-.247H41.6a.247.247 0 100 .493h.493a.246.246 0 00.244-.246z"
            transform="translate(-30.775 -23.357)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M57.832 35a.247.247 0 10-.487.078.812.812 0 01.01.136.863.863 0 01-.035.244.246.246 0 00.167.306.25.25 0 00.069.01.247.247 0 00.237-.177 1.358 1.358 0 00.055-.38 1.312 1.312 0 00-.016-.217z"
            transform="translate(-42.8 -26.213)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M39.8 58h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-29.051 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M33.8 58h-.493a.247.247 0 000 .493h.493a.247.247 0 100-.493z"
            transform="translate(-24.531 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M44.051 49.247A.246.246 0 0043.8 49h-.493a.247.247 0 000 .493h.493a.246.246 0 00.251-.246z"
            transform="translate(-32.066 -36.92)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M38.051 49.247A.246.246 0 0037.8 49h-.493a.247.247 0 000 .493h.493a.246.246 0 00.251-.246z"
            transform="translate(-27.545 -36.92)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M45.785 58h-.475a.247.247 0 100 .493h.49l.007-.247v.247a.239.239 0 00.238-.247.254.254 0 00-.26-.246z"
            transform="translate(-33.571 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M49.617 50.269a.247.247 0 00.194-.4 1.366 1.366 0 00-.463-.377.247.247 0 10-.22.442.865.865 0 01.3.24.247.247 0 00.189.095z"
            transform="translate(-36.531 -37.272)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M53.411 39.67a.856.856 0 01-.333.067h-.053a.247.247 0 100 .493h.053a1.346 1.346 0 00.524-.105.246.246 0 00-.191-.455z"
            transform="translate(-39.384 -29.875)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M26.872 26.9a.247.247 0 00.157-.311.861.861 0 01-.043-.268.966.966 0 01.007-.111.246.246 0 10-.489-.062 1.434 1.434 0 00-.011.171 1.357 1.357 0 00.067.424.247.247 0 00.234.17.239.239 0 00.078-.013z"
            transform="translate(-19.58 -19.538)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M21.8 58h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-15.489 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M32.18 48.181a.247.247 0 00.1-.471.872.872 0 01-.3-.231.247.247 0 10-.377.317 1.365 1.365 0 00.475.362.248.248 0 00.102.023z"
            transform="translate(-23.386 -35.708)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M54.188 31.192a1.341 1.341 0 00-.571-.178.247.247 0 00-.038.492.849.849 0 01.362.113.247.247 0 10.247-.427z"
            transform="translate(-39.816 -23.367)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M27.8 58h-.493a.247.247 0 000 .493h.493a.247.247 0 000-.493z"
            transform="translate(-20.01 -43.701)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M31.061 42.575a.856.856 0 01.153-.348.247.247 0 10-.4-.292 1.351 1.351 0 00-.24.548.247.247 0 00.2.289.246.246 0 00.289-.2z"
            transform="translate(-22.653 -31.52)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M44.849 6.712a1.356 1.356 0 10-1.356-1.356 1.358 1.358 0 001.356 1.356zm0-2.219a.863.863 0 11-.863.863.864.864 0 01.863-.863z"
            transform="translate(-32.389 -3.014)"
          />
          <path
            fill="#0074f9"
            stroke="#0074f9"
            strokeWidth="0.3px"
            d="M7.972 31a1.479 1.479 0 101.479 1.479A1.481 1.481 0 007.972 31zm0 2.465a.986.986 0 11.986-.986.987.987 0 01-.986.986z"
            transform="translate(-4.51 -23.357)"
          />
        </g>
      </svg>
    ),
    receipt: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "24"}
        height={height ? height : "24"}
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fill={fill ? fill : "#000"}
          d="M21 2.21c-.13 0-.26.05-.35.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.09-.09-.22-.14-.35-.14V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
        />
      </svg>
    ),
  }
  return svgIcon[icon] ? svgIcon[icon]() : svgIcon["reset"]()
}
